import addTutorialVideo from './addTutorialVideo';
import { addFavStock, initFavStocks, removeFavStock } from './favStocks';
import listTutorials from './listTutorials';
import listTutorialVideos from './listTutorialVideos';
import listYoutubePlaylistVideo from './listYoutubePlaylistVideo';
import loadPreference from './loadPreference';
import loadUserWinRates from './loadUserWinRates';
import { listPosts, readPost } from './notificationCenter';
import orderTutorialVideos from './orderTutorialVideos';
import storePreference from './storePreference';
import updateTutorialVideo from './updateTutorialVideo';

export default {
  listTutorialVideos,
  listYoutubePlaylistVideo,
  addTutorialVideo,
  updateTutorialVideo,
  orderTutorialVideos,
  listPosts,
  readPost,
  loadPreference,
  storePreference,
  listTutorials,
  loadUserWinRates,
  initFavStocks,
  addFavStock,
  removeFavStock,
};
